import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { isAuthenticated } from 'helpers/auth';

interface IPrivateRoute extends RouteProps {
  component: React.ComponentType<RouteProps>;
}

const PrivateRoute: React.FC<IPrivateRoute> = ({
  component: Component,
  ...rest
}) => {
  const signedIn = isAuthenticated();

  return (
    <Route
      {...rest}
      render={props => {
        return signedIn ? <Component {...props} /> : <Redirect to="/login" />;
      }}
    />
  );
};

export default PrivateRoute;
